"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePhoneNumber = void 0;
const phone_1 = require("../phone");
function usePhoneNumber() {
    return {
        getFullFormattedPhoneNumber: phone_1.getFullFormattedPhoneNumber,
        parsePhoneNumber: phone_1.parsePhoneNumber,
        formatPhoneNumber: phone_1.formatPhoneNumber,
        isValidPhoneNumber: phone_1.isValidPhoneNumber,
    };
}
exports.usePhoneNumber = usePhoneNumber;
//# sourceMappingURL=usePhoneNumber.js.map